import { Box, BoxProps, Skeleton, Theme } from "@mui/material";
import * as React from "react";

export type Colors =
  | "Critical"
  | "Major"
  | "Minor"
  | "available"
  | "unavailable"
  | "inACall"
  | "Informational";

interface ItemButton {
  color: Colors;
  width?: BoxProps["width"];
}

export type ItemButtonProps =
  | ({ skeleton: true } & Partial<ItemButton>)
  | ({ skeleton?: false } & ItemButton);

const ItemButtonComputeStyle = () => ({
  height: "1.4em",
  borderRadius: "0.25rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderStyle: "solid",
  borderWidth: "1px",
  "& .MuiTypography-root": {
    display: "flex",
    lineHeight: "1.5",
  },
});

export const ItemButtonSkeleton = (
  props: React.PropsWithChildren<ItemButtonProps>
) => {
  return (
    <Skeleton variant="circular">
      <Box sx={[ItemButtonComputeStyle]} />
    </Skeleton>
  );
};

const ItemButton = ({
  ref,
  ...props
}: React.PropsWithChildren<ItemButtonProps> & {
  ref?: React.Ref<HTMLButtonElement>;
}) => {
  if (props.skeleton) return <ItemButtonSkeleton {...props} />;
  const { color } = props;

  const colorsMapping = (theme: Theme) => ({
    Critical: theme.palette.ticket.Critical.main,
    Major: theme.palette.ticket.Major.main,
    Minor: theme.palette.ticket.Minor.main,
    Informational: theme.palette.ticket.Informational.main,
    available: theme.palette.background.paper,
    unavailable: theme.palette.grey[400],
    inACall: theme.palette.meeting.background,
  });

  return (
    <Box
      sx={[
        {
          minWidth: props.width,
        },
        ItemButtonComputeStyle,
        { borderColor: (theme) => colorsMapping(theme)[color] },
        !props.width
          ? {
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }
          : {},
      ]}
    >
      {props.children}
    </Box>
  );
};

export default ItemButton;
